import React from "react";
import IconButton from '@material-ui/core/IconButton';
import GIESideBarContent from './GIESideBarContent';
import './Header.css';
import logo from '../../assets/gie.png';
import {Drawer} from "@mui/material";
import GIESvgIcon from "../GIEIcon/GIESvgIcon";
import menuIcon from '../../assets/img/icons/menu.svg';

class GIEHeaderMobile extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
        this.openSideBar = this.openSideBar.bind(this)
    }

    openSideBar = () => {
        this.setState({open: !this.state.open})
    }

    render() {
        return (
          <div>
            <div className="d-flex align-items-center gap-3">
              <IconButton onClick={this.openSideBar}>
                <GIESvgIcon icon={menuIcon}/>
              </IconButton>
              <a href="/admin/accueil" className="header-logo">
                <img alt='https://gie-sa.fr/' src={logo} height="40"/>
              </a>
            </div>

            <Drawer open={this.state.open} onClose={this.openSideBar} classes={{paper: "w-100"}}>
              <GIESideBarContent close={this.openSideBar}/>
            </Drawer>
          </div>);
    }
}

export default GIEHeaderMobile;
